import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { stringifyMembersCount } from 'utils';

export default function useNumberOfMembersWithAccess() {
  const { t } = useTranslation();

  return useCallback(
    (numberOfMembersWithAccess: number) =>
      t(...stringifyMembersCount(numberOfMembersWithAccess)),
    [t],
  );
}
